import React from 'react';
import { getFileUrl } from '../../../../store/FilesStore';
import styles from './StickerMessage.module.scss';
const StickerMessage = ({ media }) => {
    let url;
    if (media.fileId) {
        url = getFileUrl(media.fileId);
    }
    else if (media.url) {
        url = media.url;
    }
    else {
        console.error('Message have no file ID or URL');
        return null;
    }
    return React.createElement("img", { className: styles.image, src: url, alt: 'sticker' });
};
export default StickerMessage;
